import { request, handleResponse } from '@/components/http';
import Vuex from 'vuex';
import Worker from 'worker-loader!@/http-worker';

const worker = new Worker();
worker.onmessage = handleResponse;

Vue.use(Vuex);

import { LUDUM_ERROR_CODES } from '@/constants';
const { UNAUTHORIZED, FORBIDDEN } = LUDUM_ERROR_CODES;
import { ROUTES_LOGOUT, ROUTES_UNAUTHORIZED } from '@/constants/routes';
import router from '@/router';
import get from 'get-object-path';

// import the auto exporter
import modules from './modules';

const store = new Vuex.Store({
    modules: modules,
    state: {
        currentlyOpenModal: null,
        notifications: [],
        errorNotifications: [],
        successNotifications: []
    },
    mutations: {
        setModalOpen(state, modalId) {
            state.currentlyOpenModal = modalId;
        },
        closeAllModals(state) {
            state.currentlyOpenModal = null;
        }
    },
    actions: {
        post(context, payload) {
            const { url, data, config } = payload;
            return request(
                {
                    method: 'post',
                    url,
                    data,
                    config
                },
                worker
            );
        },

        get(context, payload) {
            const { config, params, url } = payload;

            return request(
                {
                    method: 'get',
                    url,
                    config,
                    params
                },
                worker
            ).catch(error => {
                const status = get(error, 'response.status');

                if (status === UNAUTHORIZED) {
                    handleUnauthorized();
                    throw error;
                }

                if (status === FORBIDDEN) {
                    const message = get(error, 'response.data.message');
                    handleForbidden(message);
                    return message;
                }

                throw error;
            });
        },

        delete(context, payload) {
            const { config, url } = payload;

            return request(
                {
                    method: 'delete',
                    url,
                    config
                },
                worker
            ).catch(error => {
                const status = get(error, 'response.status');

                if (status === UNAUTHORIZED) {
                    handleUnauthorized();
                    return error.response.statusText;
                }

                throw error;
            });
        },
        setModalOpen({ commit }, modalId) {
            commit('setModalOpen', modalId);
        },
        closeAllModals({ commit }) {
            commit('closeAllModals');
        }
    }
});

const initialStateCopy = Object.assign({}, store.state);

export function resetState() {
    store.replaceState(initialStateCopy);
}

function handleUnauthorized() {
    router.push({ name: ROUTES_LOGOUT }).catch(() => {});
}

function handleForbidden(message) {
    router.push({ name: ROUTES_UNAUTHORIZED, params: { message: message } }).catch(() => {});
}

export default store;
